module.exports = __webpack_public_path__ + "static/media/08_ladoalado_mobile.61a7f189.jpg";